import {useTranslation} from '@/translations/i18n.tsx'
import {ClockRewindIcon, Mail01Icon} from '@/components/ui/icon/Icon'
import {StyledTabButton, StyledTabsBar} from '@/features/mailer/components/mailer-tabs/style'

export type MailerTab = 'compose' | 'history'

interface MailerTabsProps {
    active: MailerTab
    onChange: (tab: MailerTab) => void
}

export const MailerTabs = ({active, onChange}: MailerTabsProps) => {
    const {t} = useTranslation()

    return (
        <StyledTabsBar role="tablist">
            <StyledTabButton
                type="button"
                role="tab"
                aria-selected={active === 'compose'}
                $active={active === 'compose'}
                onClick={() => onChange('compose')}
            >
                <Mail01Icon />
                {t('mailer:tab_compose')}
            </StyledTabButton>
            <StyledTabButton
                type="button"
                role="tab"
                aria-selected={active === 'history'}
                $active={active === 'history'}
                onClick={() => onChange('history')}
            >
                <ClockRewindIcon />
                {t('mailer:tab_history')}
            </StyledTabButton>
        </StyledTabsBar>
    )
}

MailerTabs.displayName = 'MailerTabs'
